import React, { FunctionComponent } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CustomInput } from "../../../CustomInput";
import { ISectionProps } from "../ISectionProps";
import { IZapierState } from "../../IState";
import { useNewInput } from "../../new-input.hook";
import { Button } from "../../../Button";
import { NewInputDialog } from "../NewInputDialog";

export const Zapier: FunctionComponent<ISectionProps<IZapierState>> = (props): JSX.Element => {
    const {
        data,
        onChange
    } = props;

    const { isNewInputDialogOpen, toggleNewInputDialog } = useNewInput();

    return (
        <Box ml={2} mt={1} >
            <Typography sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18, mb: 1 }} >
                Zapier
            </Typography>
            <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
                <CustomInput
                    name="zapierWebhookAddress"
                    value={data.zapierWebhookAddress}
                    width={220}
                    height={35}
                    label={{ text: "Webhook Address", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="webhook address"
                    onChange={props.onChange}
                />
                {
                    props.fields.map((field, index) => {
                        const objName = Object.keys(field)[0] as keyof typeof field;

                        return (
                            <CustomInput
                                width={220}
                                height={35}
                                label={{ text: objName.toString() }}
                                name={objName.toString()}
                                value={field[objName]}
                                onChange={(event) => props.onChangeField(event as React.ChangeEvent<HTMLInputElement>, index)}
                            />
                        )
                    })
                }
            </Box>
            <Box mt={2} >
                <Button label="Add new field" width={120} height={35} onClick={toggleNewInputDialog} />
            </Box>
            <NewInputDialog
                open={isNewInputDialogOpen}
                onClose={toggleNewInputDialog}
                onClick={(name, value) => {
                    props.onAdd(name, value);
                    toggleNewInputDialog();
                }}
            />
        </Box>
    )
}